import { Component } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-new-search',
  imports: [MatIconModule, TranslateModule],
  templateUrl: './new-search.component.html',
  styleUrl: './new-search.component.scss'
})
export class NewSearchComponent {

}
